import { apiClient } from './api-client';

export interface Tag {
  id: string;
  tenantId: string;
  name: string;
  color: string | null;
  description: string | null;
  createdAt: string;
}

export interface TagWithUsage extends Tag {
  usageCount: number;
}

export interface TagSuggestion {
  name: string;
  count: number;
}

export interface CreateTagDto {
  name: string;
  color?: string;
  description?: string;
}

export type UpdateTagDto = Partial<CreateTagDto>;

export const tagService = {
  async list(search?: string): Promise<TagWithUsage[]> {
    const { data } = await apiClient.get<TagWithUsage[]>('/tags', {
      params: search ? { search } : undefined,
    });
    return data;
  },

  async suggestions(q?: string, limit = 20): Promise<TagSuggestion[]> {
    const { data } = await apiClient.get<TagSuggestion[]>('/tags/suggestions', {
      params: { q, limit },
    });
    return data;
  },

  async create(dto: CreateTagDto): Promise<Tag> {
    const { data } = await apiClient.post<Tag>('/tags', dto);
    return data;
  },

  async update(id: string, dto: UpdateTagDto): Promise<Tag> {
    const { data } = await apiClient.patch<Tag>(`/tags/${id}`, dto);
    return data;
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/tags/${id}`);
  },
};
